// extracted by mini-css-extract-plugin
export default {"cls1":"Jr6_gK4YybDcLzodPeLs","cls2":"Ybk1wI1OMowSrDj6LoKn Jr6_gK4YybDcLzodPeLs"};